import { useApi, useToaster, type ExpertCustomerStoryDetails } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed, watch, type MaybeRefOrGetter, toValue } from "vue";

export function useExpertCustomerStory(storyId: MaybeRefOrGetter<number | null | undefined>) {
    const api = useApi();
    const toaster = useToaster();
    const storyIdValue = computed(() => toValue(storyId));

    const query = useQuery<ExpertCustomerStoryDetails>({
        enabled: computed(() => storyIdValue.value != null),
        queryKey: computed(() => ["expert", "customer-stories", storyIdValue.value]),
        queryFn: () => api.expert.getCustomerStory({
            params: { story: storyIdValue.value as number },
        }),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    watch(() => query.error.value, (error) => {
        if (!error) return;
        toaster.create({ title: "Failed to load case study", type: "error" });
    });

    return query;
}

export default useExpertCustomerStory;
